import React, { useState } from 'react';

const ParticipantJoin = ({ participants, readNotifications, setReadNotifications, onMarkAsRead }) => {
    const [expanded, setExpanded] = useState(null);

    const handleClick = (id) => {
        // 🔹 Call backend
        if (onMarkAsRead) {
            onMarkAsRead(id);
        }

        // 🔹 Local mark as read
        setReadNotifications((prev) => new Set(prev).add(id));

        // 🔹 Toggle expanded
        setExpanded(expanded === id ? null : id);
    };

    if (!participants || participants.length === 0) {
        return (
            <div style={{ padding: '10px', textAlign: 'center', color: '#666' }}>
                No participant join notifications
            </div>
        );
    }

    return participants.map((n) => {
        const isRead = readNotifications.has(n.notification_id);
        const isExpanded = expanded === n.notification_id;

        return (
            <div
                key={n.notification_id}
                onClick={() => handleClick(n.notification_id)}
                style={{
                    padding: '10px 12px',
                    background: isRead ? '#e0e0e0' : '#f9f9f9',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                }}
            >
                <div style={{ fontWeight: '500' }}>{n.message}</div>
                <div style={{ fontSize: '0.85rem', color: '#555' }}>
                    {new Date(n.created_at).toLocaleString()}
                </div>

                {/* Expanded details */}
                {isExpanded && n.participant && (
                    <div
                        style={{
                            marginTop: '8px',
                            padding: '8px',
                            background: '#fff',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            fontSize: '0.85rem'
                        }}
                    >
                        <div><strong>Participant ID:</strong> {n.participant.id}</div>
                        <div><strong>Name:</strong> {n.participant.name}</div>
                        <div><strong>Status:</strong> {n.participant.status}</div>
                    </div>
                )}
            </div>
        );
    });
};

export default ParticipantJoin;
